<template>
  <HomeWrapper>
    <div class="home-content">
      <section class="content">
        <HomeHeader
          class="mt-[100px] mb-[92px]"
          title="核心优势"
          desc="五大优势，满足企业用户深层次、个性化需求"
        />
        <div class="content-list flex justify-around gap-[85px]">
          <div class="core-item w-[130px]">
            <div class="img w-[50px] object-cover">
              <img src="../../assets/img/core-1.png" alt="" />
            </div>
            <div class="content">
              <h3 class="title">高精度</h3>
              <p class="desc">
                商用精度高<br />
                深度使用可持续提升
              </p>
            </div>
          </div>
          <div class="core-item w-[130px]">
            <div class="img w-[50px] object-cover">
              <img src="../../assets/img/core-2.png" alt="" />
            </div>
            <div class="content">
              <h3 class="title">小样本</h3>
              <p class="desc">
                小样本即可投产<br />
                降低样本需求量级
              </p>
            </div>
          </div>
          <div class="core-item w-[130px]">
            <div class="img w-[50px] object-cover">
              <img src="../../assets/img/core-3.png" alt="" />
            </div>
            <div class="content">
              <h3 class="title">集成性强</h3>
              <p class="desc">
                可适配任意大模型<br />
                个性化对接各类接口
              </p>
            </div>
          </div>
          <div class="core-item w-[130px]">
            <div class="img w-[50px] object-cover">
              <img src="../../assets/img/core-4.png" alt="" />
            </div>
            <div class="content">
              <h3 class="title">可定制</h3>
              <p class="desc">
                支持私有化部署<br />
                可个性化定制项目
              </p>
            </div>
          </div>
          <div class="core-item w-[130px]">
            <div class="img w-[50px] object-cover">
              <img src="../../assets/img/core-5.png" alt="" />
            </div>
            <div class="content">
              <h3 class="title">安全可信</h3>
              <p class="desc">
                经头部企业权威验证<br />
                安全性、稳定性强
              </p>
            </div>
          </div>
        </div>
      </section>
      <section class="content">
        <HomeHeader
          class="mt-[100px] mb-[48px]"
          title="行业应用场景"
          desc="核心行业覆盖，探索企业数智化转型更多可能"
        />
        <div class="content-list flex flex-wrap justify-between">
          <div
            class="content-item-hyyy w-[245px] h-[310px] relative cursor-pointer"
            v-for="(solution, idx) in solutions"
            :key="solution.id"
            @click="handleSolutionClick(solution, idx)"
          >
            <div class="img w-full h-full">
              <img
                class="w-full h-full object-cover"
                :src="solution.icon"
                :alt="solution.title"
              />
            </div>
            <div class="features absolute top-0 left-0 w-full">
              <h3 class="title">{{ solution.title }}</h3>
              <ul>
                <li v-for="feature in solution.features" :key="feature">
                  {{ feature }}
                </li>
              </ul>
            </div>
            <div class="title absolute bottom-0 left-0 w-full h-[50px]">
              <h3>{{ solution.industry }}</h3>
            </div>
          </div>
        </div>
      </section>
      <section class="content" style="margin-top: -56px">
        <HomeHeader
          class="mt-[100px] mb-[98px]"
          title="AI核保员"
          desc="赋能广大险企，提质增效同时管控风险"
        />
        <div class="content-list mt-[98px]">
          <div class="ai-hby flex justify-around gap-[85px]">
            <div class="img-content mt-[52px]">
              <p class="dot">核保能力标准化</p>
              <p class="desc">融合专业核保员能力，拉齐业务</p>
              <p class="dot">全面提升核保效率</p>
              <p class="desc">3分钟精准完成一单核保，减少排队等待</p>
              <p class="dot">深度做好核保风控</p>
              <p class="desc">高精度媲美人工核保水准，减少决策风险</p>
              <div class="btn" @click="router.push('/demo')">预约演示</div>
            </div>
            <div class="img relative h-[338px] w-[677px]">
              <img
                class="w-full h-full object-cover"
                src="../../assets/img/ai-hby.png"
                alt=""
              />
              <div class="absolute top-[221px] left-[16px] hby-img-content">
                <p class="title">01</p>
                <p class="b-title">AI数据服务</p>
                <p class="desc">
                  核保信息智能抽取与归<br />
                  一化管理
                </p>
              </div>
              <div class="absolute top-[90px] left-[46px] hby-img-content">
                <p class="title">02</p>
                <p class="b-title">智能QA</p>
                <p class="desc">
                  数据质检，QA修正<br />
                  数据训练内循环
                </p>
              </div>
              <div class="absolute top-[-9px] left-[234px] hby-img-content">
                <p class="title">03</p>
                <p class="b-title">AI自学习系统</p>
                <p class="desc">
                  灵活创建和训练业务模型<br />
                  自适应学习深度提升精度
                </p>
              </div>
              <div class="absolute top-[50px] left-[504px] hby-img-content">
                <p class="title">04</p>
                <p class="b-title">AI大模型规则引擎</p>
                <p class="desc">
                  依托提取数据、核保手册等<br />
                  智能输出核保结论
                </p>
              </div>
              <div class="absolute top-[209px] left-[505px] hby-img-content">
                <p class="title">05</p>
                <p class="b-title">核保知识库</p>
                <p class="desc">
                  依托提取数据、核保手册等<br />
                  智能输出核保结论
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="content">
        <HomeHeader
          class="mt-[100px] mb-[81px]"
          title="AI偏差报告助手"
          desc="强化企业质量管理，从做好偏差报告开始"
        />
        <div class="content-list">
          <div class="ai-yzx flex justify-around gap-[85px]">
            <div class="img-content mt-[63px] w-[336px]">
              <p class="dot">融合世界500强优秀经验</p>
              <p class="desc">
                前沿AI技术结合世界500强药企优秀偏差管理实践打造 行业适用性强
              </p>
              <p class="dot">标准化偏差报告和审核流程</p>
              <p class="desc">
                推动偏差信息收集、要素补全、数据检查、报告撰写、
                内容审核等流程自动化
              </p>
              <p class="dot">对齐国际标准，强化质量管理</p>
              <p class="desc">
                经头部企业严格的安全校验，可加快偏差关闭进度，
                强化质量管理，推动实现工艺提升
              </p>
              <div class="btn" @click="router.push('/demo')">预约演示</div>
            </div>
            <div class="img relative h-[398px] w-[604px]">
              <img
                class="w-full h-full object-cover"
                src="../../assets/img/ai-bgzs.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </section>
      <section class="content">
        <HomeHeader
          class="mt-[100px] mb-[56px]"
          title="AI一站销"
          desc="懂你，更懂你的客户"
        />
        <div class="content-list">
          <div class="ai-yzx flex justify-around gap-[85px]">
            <div class="img relative h-[338px] w-[625.3px]">
              <img
                class="w-full h-full object-cover"
                src="../../assets/img/ai-yzx.png"
                alt=""
              />
            </div>
            <div class="img-content mt-[44px]">
              <p class="dot">全生命周期管理</p>
              <p class="desc">赋能销售、客服、私域运营多场景</p>
              <p class="dot">多模态能力支持</p>
              <p class="desc">超强文本、图像、视频生成能力</p>
              <p class="dot">人机可高度协同</p>
              <p class="desc">核心业务AI托管，灵活转人工，无缝切换</p>
              <div class="btn" @click="router.push('/demo')">马上体验</div>
            </div>
          </div>
        </div>
      </section>

      <section class="relative mt-[100px] h-[387px]">
        <div class="absolute inset-0">
          <img
            class="w-full h-full object-cover absolute top-0 left-0"
            src="../../assets/img/home-bg.png"
            alt=""
          />
        </div>
        <div
          class="home-banner-content content relative h-full flex items-center"
        >
          <div>
            <h1
              class="text-[50px] font-extrabold mb-[16px]"
              style="color: #3a71ea"
            >
              立即体验，快人一步开启数智化之旅
            </h1>
            <h2 class="text-[38px] font-medium mb-[40px]">专家顾问一对一服</h2>
            <n-button
              type="primary"
              size="large"
              class="btn rounded"
              @click="router.push('/demo')"
            >
              预约演示
            </n-button>
          </div>
        </div>
      </section>
    </div>
  </HomeWrapper>
</template>

<script setup lang="ts">
// import { solutions } from '@/constants/solutions'
const router = useRouter()
import jrhy from '@/assets/img/jrhy.png'
import jyhy from '@/assets/img/jyhy.png'
import dlhy from '@/assets/img/dlhy.png'
import lshy from '@/assets/img/lshy.png'
import zyhy from '@/assets/img/zyhy.png'
import nyhy from '@/assets/img/nyhy.png'
import fhy from '@/assets/img/fhy.png'
import gd from '@/assets/img/gd.png'
const solutions = [
  {
    id: 'intelligent-underwriting',
    title: '智能核保',
    features: ['核保信息识别', '智能核保决策', '核保结论出具'],
    industry: '金融保险行业',
    icon: jrhy
  },
  {
    id: 'intelligent-production',
    title: '智能生产',
    features: ['偏差要素补齐', '偏差报告撰写', '偏差内容审核'],
    industry: '制药行业',
    icon: zyhy
  },
  {
    id: 'intelligent-writing',
    title: '智能写作',
    features: ['专业论文写作', '教学案例写作', '行业研究分析'],
    industry: '教育行业',
    icon: jyhy
  },

  {
    id: 'intelligent-trading',
    title: '智能交易',
    features: ['设备运行监测', '运维数据分析', '巡检报告生成'],
    industry: '能源行业',
    icon: nyhy
  },
  {
    id: 'intelligent-operations',
    title: '智能运维',
    features: ['交易知识管理', '交易智能运营', '交易决策输出'],
    industry: '能源、电力行业',
    icon: dlhy
  },
  {
    id: 'intelligent-sales',
    title: '智能销售',
    features: ['多维信息识别', '客户需求洞察', '客服内容质检'],
    industry: '零售行业',
    icon: lshy
  },

  {
    id: 'intelligent-customer-service',
    title: '智能客服',
    features: ['智能业务应答', '精准营销获客', '私域运营管理'],
    industry: '泛行业',
    icon: fhy
  },
  {
    id: 'more-solutions',
    title: '通用',
    features: [
      '智能信息采集',
      '行业知识图谱',
      '知识检索问答',
      '智能合同审查',
      '智能投标管理'
    ],
    industry: '更多…',
    icon: gd
  }
]

const handleSolutionClick = (solution: any, idx: number) => {
  if (idx < 4) {
    // 前四个solutions都跳转到/home/industry-solutions/education页面，通过id参数区分
    const solutionId = idx + 1 // id从1开始
    router.push(`/home/industry-solutions/education?id=${solutionId}`)
  }
}
</script>

<style scoped lang="scss">
.btn {
  width: 104px;
  height: 34px;
  background: #3d6bff;
  border-radius: 8px;
  font-weight: 500;
  font-size: 16px;
  color: #ffffff;
  line-height: 34px;
  text-align: center;
  cursor: pointer;
}
.img-content {
  .dot {
    font-size: 16px;
    color: #333333;
    line-height: 22px;
    margin-bottom: 6px;
    &::before {
      content: '';
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: #1a1fff;
      margin-right: 8px;
      vertical-align: middle;
      margin-top: -2px;
    }
  }
  .desc {
    font-weight: 400;
    font-size: 14px;
    color: #979797;
    line-height: 20px;
    margin-bottom: 30px;
  }
}
.content-item-hyyy {
  margin-bottom: 56px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:nth-child(-n + 4) {
    cursor: pointer;

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
    }
  }

  .features {
    display: none;
    background: rgba(0, 0, 0, 0.6);
    height: calc(100% - 50px);
    text-align: center;
    h3 {
      font-weight: 500;
      font-size: 20px;
      color: #ffffff;
      line-height: 30px;
      margin-bottom: 10px;
      margin-top: 25px;
    }
    ul {
      li {
        font-size: 16px;
        color: #ffffff;
        line-height: 39px;
      }
    }
  }
  &:hover {
    .features {
      display: block;
    }
  }
  > .title {
    background: rgba(0, 0, 0, 0.6);
    h3 {
      font-weight: 400;
      font-size: 20px;
      color: #ffffff;
      line-height: 50px;
      text-align: center;
    }
  }
}
.ai-hby {
  .hby-img-content {
    // width: 140px;
    .title {
      font-weight: 600;
      font-size: 18px;
      color: #1a1fff;
      line-height: 25px;
      margin-bottom: 4px;
    }
    .b-title {
      font-weight: 600;
      font-size: 16px;
      color: #333333;
      line-height: 22px;
    }
    .desc {
      font-size: 14px;
      color: #333333;
      line-height: 20px;
    }
  }
}
.core-item {
  .img {
    margin: 0 auto 28px;
  }
  .content {
    text-align: center;
    .title {
      font-weight: 600;
      font-size: 18px;
      color: #020a1a;
      line-height: 25px;
      margin-bottom: 4px;
    }
    .desc {
      font-weight: 400;
      font-size: 14px;
      color: #939aa9;
      line-height: 21px;
    }
  }
}
</style>
